import { render, staticRenderFns } from "./AvatarPopOver.vue?vue&type=template&id=97e0cfd2&scoped=true&"
import script from "./AvatarPopOver.vue?vue&type=script&lang=js&"
export * from "./AvatarPopOver.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPopOver.vue?vue&type=style&index=0&id=97e0cfd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e0cfd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VDivider,VHover,VMenu,VSpacer})
